import { authSelectors, dataTrackingOperations, hooks, mainOperations, mainSelectors } from 'state'
import { Button, Container, DropdownMenu, Modal, Text, POSInviteManager, EdgeSubscriptionsManager } from 'components'
import EdgeSubscriptionEditModal from '../../shared/EdgeSubscriptionsManager/EdgeSubscriptionEditModal'
import EdgeSubscriptionDuplicateModal from '../../shared/EdgeSubscriptionsManager/EdgeSubscriptionDuplicateModal'
import EdgeSubscriptionHistoryModal from '../../shared/EdgeSubscriptionsManager/EdgeSubscriptionHistoryModal'
import ConfirmDialog from '../../shared/ConfirmDialog'
import { useEffect, useState } from 'react'
import { IoMdClose, IoMdArrowBack } from 'react-icons/io'
import { getColor, usePrevious } from 'utils'
import { WorkbookDownload, WorkbookExport, WorkbookFilterList, WorkbookFilterSave } from '.'
import { v4 as uuid } from 'uuid'
import { DownloadIcon, FilterListIcon, SaveIcon } from 'assets'
import { AiOutlineFlag } from "react-icons/ai";
import StyledWorkbookActions from './workbook-actions-styled'
import { 
  sendNowTitle,
  myFiltersTitle,
  saveFilterTitle,
  downloadTitle,
  scheduledSendTitle,
  setDefaultEmailBodyContent,
  filterWarningTitle,
  filterWarningMessage,
  filterActionSuggestion,
  okLabel,
  saveFilterLabel,
  yourFiltersLabel,
  sendLabel,
  premiumDownloadTitle,
  territoriesLabel
} from 'utils/constants/index'
import { fieldsInitialValues } from 'utils/constants'
import WorkbookSendExport from './workbook-send-export'
import ArrowButton from 'components/shared/ui-elements/arrow-button';
import WorkbookFilters from './workbook-filters'
import { isDownloadAllowed  } from 'utils/tools'
import { IOptionsSend } from './interfaces'
import PremiumDownload from './PremiumDownload'
import axios from "axios";
import { store } from "state"; 
import WorkbookTerritories from './workbook-territories/workbook-territories'
import WorkbookTerritoryList from './workbook-territories/WorkbookTerritoryList'

export const WorkbookActions = () => {
  const { useAppSelector, useAppDispatch } = hooks
  const [posInviteKey, setPosInviteKey] = useState(0)
  const [edgeSubscriptionsKey, setEdgeSubscriptionsKey] = useState(0)
  const [edgeSubscriptionsInitialTab, setEdgeSubscriptionsInitialTab] = useState<'new' | 'tracking'>('new')
  const [edgeSubscriptionsModalSize, setEdgeSubscriptionsModalSize] = useState<'normal' | 'wide' | 'full'>('normal')
  const edgeSubscriptionsSizeOptions = [
    { key: 'normal', label: 'Standard', value: 'normal' },
    { key: 'wide', label: 'Wide', value: 'wide' },
    { key: 'full', label: 'Fullscreen', value: 'full' },
  ]
  const { selectmain } = mainSelectors
  const { selectAuth } = authSelectors
  const { getWorkBookUrl, setMainContent, setModalOpen, setSelectedModalContent, getSavedFilterByGuid} = mainOperations
  const { selectedState, selectedWorkbook, selectedSuscriptionIndex, userReports, error , mainContent, isModalOpen, workbookFilters, selectedWorkbookV2,workbookElements, selectedModalContent, isWorkbookActionsOpen} = useAppSelector(selectmain)
  const { user } = useAppSelector(selectAuth)
  const dispatch = useAppDispatch()
  const prevState = usePrevious(selectedState)
  const prevSelectedModalContent = usePrevious(selectedModalContent) as string | undefined
  const brandName = user?.profile?.companyName || user?.profile?.name || 'Mi Marca'
  const userRole = user?.profile?.role?.includes('customer_success') ? 'customer_success' : 'brand'

  useEffect(() => {
    if (selectedModalContent === 'posInvite' && isModalOpen) {
      setPosInviteKey(prev => prev + 1);
    }
  }, [selectedModalContent, isModalOpen]);

  useEffect(() => {
    if (selectedModalContent === 'edgeSubscriptions' && isModalOpen) {
      setEdgeSubscriptionsKey(prev => prev + 1);
    }
  }, [selectedModalContent, isModalOpen]);

  // Resetear la pestaña inicial cuando se cierra el modal de edge subscriptions
  useEffect(() => {
    if (!isModalOpen || selectedModalContent !== 'edgeSubscriptions') {
      // Si se cierra o cambia a otro modal, resetear a 'new' para la próxima apertura
      setEdgeSubscriptionsInitialTab('new');
    }
  }, [isModalOpen, selectedModalContent]);

  useEffect(() => {
    const wasEdgeSubscriptionChild =
      prevSelectedModalContent?.startsWith('edgeSubscriptionEdit-') ||
      prevSelectedModalContent?.startsWith('edgeSubscriptionDuplicate-') ||
      prevSelectedModalContent?.startsWith('edgeSubscriptionHistory-');

    if (wasEdgeSubscriptionChild && selectedModalContent === 'edgeSubscriptions') {
      setEdgeSubscriptionsInitialTab('tracking');
    }
  }, [prevSelectedModalContent, selectedModalContent]);

  const isEdgeSubscriptionsModal = selectedModalContent === 'edgeSubscriptions' ||
    selectedModalContent?.startsWith('edgeSubscriptionEdit-') ||
    selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') ||
    selectedModalContent?.startsWith('edgeSubscriptionHistory-')

  const handleEdgeSubscriptionsTabChange = (tab: 'new' | 'tracking') => {
    setEdgeSubscriptionsModalSize(tab === 'new' ? 'normal' : 'full')
  }

  useEffect(() => {
    if (selectedModalContent?.startsWith('edgeSubscriptionEdit-') ||
        selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') ||
        selectedModalContent?.startsWith('edgeSubscriptionHistory-')) {
      setEdgeSubscriptionsModalSize('normal')
    } else if (selectedModalContent === 'edgeSubscriptions') {
      setEdgeSubscriptionsModalSize(edgeSubscriptionsInitialTab === 'tracking' ? 'full' : 'normal')
    }
  }, [selectedModalContent, edgeSubscriptionsInitialTab])

  const selectedEdgeSubscriptionsSizeOption =
    edgeSubscriptionsSizeOptions.find(option => option.value === edgeSubscriptionsModalSize) ||
    edgeSubscriptionsSizeOptions[0]

  useEffect(() => {
    if (!isModalOpen || !isEdgeSubscriptionsModal) {
      setEdgeSubscriptionsModalSize('normal')
    }
  }, [isModalOpen, isEdgeSubscriptionsModal])
  const workbookReports = userReports?.filter(({ workbookGuid: reportWorkbookGuid }: any) => reportWorkbookGuid === selectedWorkbookV2?.workbookGuid)
  let attachments: {label:string, value: string}[] | undefined= []

  attachments = workbookElements?.map(({elementDisplayName, workbookElementGuid} : any)=>({
    label: elementDisplayName,
    value: workbookElementGuid
  }))
  const fieldsInitialValuesExtended = {
    ...fieldsInitialValues,
    body: setDefaultEmailBodyContent(selectedWorkbookV2?.workbookDisplayName),
    dashBoardItems: (()=>{
      return ([(selectedWorkbookV2?.workbookName || selectedWorkbook?.workbookTitle) === 'Stock Report' ? attachments?.find((attachment:any)=>attachment.label === 'Stock detail') : attachments?.[0]])
    })()
  }
  const [initialValues, setInitialValues] = useState<any>(null)

  // const [isSideMenuOpen, setIsModalOpen] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState()
  const [ isEditFilterClicked , setIsEditFilterClicked] = useState(false)
  const [isSendScheduled,setIsSendScheduled] = useState(false)

  let userSettings = (((user as any)?.subscriptions[selectedSuscriptionIndex].settings))

  let canDownload = true
   

  const [showReportList, setShowReportList] = useState<any>(undefined)

  const [showIframe, setShowIframe] = useState(false);

  const [selectedTerritory, setSelectedTerritory] = useState<{ id: string; name: string } | null>(null);
  
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  



  const selecteSideMenuTabTitles: any = {
    filters: myFiltersTitle,
    selection: saveFilterTitle,
    download: downloadTitle,
    territories: territoriesLabel,
    premiumDownload: premiumDownloadTitle,
    send: sendLabel,
    schedule: scheduledSendTitle,
    sendNow: sendNowTitle,
    error: filterWarningTitle,
    posInvite: 'POS Invitation Manager',
    edgeSubscriptions: 'Edge Subscriptions'
  }

  useEffect(() => {
    if (prevState && selectedState) {
      dispatch(getWorkBookUrl({
        workbookGuid: selectedWorkbook.workbookGuid,
        state: selectedState
      }));
    }
  }, [selectedState])

  useEffect(() => {
  }, [selectedFilter])
  useEffect(() => {
    if (error?.message === 'Rejected') {
      dispatch(setModalOpen(true));
      dispatch(setSelectedModalContent('error'))
    }
  }, [error])

  useEffect(()=>{
    if(mainContent && isModalOpen){
      if (selectedModalContent === 'posInvite') {
        return
      }
      // No sincronizar con mainContent cuando el modal de Edge Subscriptions está abierto
      // (se abre desde el header y no desde el flujo de mainContent)
      if (selectedModalContent === 'edgeSubscriptions' ||
          selectedModalContent?.startsWith('edgeSubscriptionEdit-') ||
          selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') ||
          selectedModalContent?.startsWith('edgeSubscriptionHistory-')) {
        return
      }
      mainContent === 'home' && dispatch(setModalOpen(false))
      dispatch(setModalOpen(isModalOpen))
      dispatch(setSelectedModalContent(mainContent))
    }
  },[mainContent, isModalOpen, selectedModalContent])

  useEffect(() => {
    if ((workbookElements ?? []).length > 0) {
      const attachments = (workbookElements ?? []).map(({ elementDisplayName, workbookElementGuid }) => ({
        label: elementDisplayName,
        value: workbookElementGuid
      }))
  
      const defaultDashboardItem =
        (selectedWorkbookV2?.workbookName || selectedWorkbook?.workbookTitle) === 'Stock Report'
          ? attachments.find((attachment: any) => attachment.label === 'Stock detail')
          : attachments[0]
  
      setInitialValues({
        ...fieldsInitialValues,
        body: setDefaultEmailBodyContent(selectedWorkbookV2?.workbookDisplayName),
        dashBoardItems: [defaultDashboardItem]
      })
    }
    }, [workbookElements, selectedWorkbookV2?.workbookDisplayName])
  
  useEffect(() => {
    if (!showIframe) {
      setHasUnsavedChanges(false);
    }
  }, [showIframe]);
     

  const handleCloseOnClick = () => {
    if (selectedModalContent === 'territories' && showIframe && hasUnsavedChanges) {
      setShowUnsavedChangesDialog(true);
      return;
    }

    if (selectedModalContent === 'posInvite' || selectedModalContent === 'edgeSubscriptions' || 
        selectedModalContent?.startsWith('edgeSubscriptionEdit-') || 
        selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') || 
        selectedModalContent?.startsWith('edgeSubscriptionHistory-')) {
      dispatch(setModalOpen(false));
      setTimeout(() => {
        dispatch(setSelectedModalContent('filters'));
      }, 300);
      return;
    }

    if(workbookReports?.length && isSendScheduled){
      if(showReportList){
        dispatch(setModalOpen(false))
      }else{
        setShowReportList(true)
        dispatch(setModalOpen(true))
      }
    }else{
      setShowReportList(false)
      dispatch(setModalOpen(false))
    }
    setInitialValues(fieldsInitialValuesExtended)
    setSelectedFilter(undefined)
   
    if (selectedModalContent !== 'posInvite') {
      dispatch(setMainContent('home'))
    }
    
    setHasUnsavedChanges(false)
  }

  const handleConfirmClose = () => {
    setShowUnsavedChangesDialog(false);
    setHasUnsavedChanges(false);
    
    if(workbookReports?.length && isSendScheduled){
      if(showReportList){
        dispatch(setModalOpen(false))
      }else{  
        setShowReportList(true)
        dispatch(setModalOpen(true))
      }
    }else{
      setShowReportList(false)
      dispatch(setModalOpen(false))
    }
    setInitialValues(fieldsInitialValuesExtended)
    setSelectedFilter(undefined)
    dispatch(setMainContent('home'))
  };

  const handleCancelClose = () => {
    setShowUnsavedChangesDialog(false);
  }

  
  const setNowOnRequestClose = () => {
    dispatch(setModalOpen(false))
    setInitialValues(fieldsInitialValuesExtended)
  }

  const onSaveFilter = (filterGuidParam: string) => {
    setSelectedFilter(undefined)
    dispatch(setModalOpen(false))
  }

  const [isLoadingFilter, setIsLoadingFilter] = useState(false);

  const onEditFilter = async (controlFilterParams: any) => {
  dispatch(setMainContent('selection'));
  dispatch(setSelectedModalContent('selection'));
  setIsEditFilterClicked(true);

  try {
    const formattedFilter = await dispatch(getSavedFilterByGuid({
      workbookGuid: selectedWorkbookV2?.workbookGuid,
      savedFilterGuid: controlFilterParams.savedFilterGuid
    })).unwrap()

    setSelectedFilter(formattedFilter)
  } catch (error) {
  }
}




  const handleSendTypeChange = ({action: sendTypeSelected}:IOptionsSend) =>{
    if(sendTypeSelected === 'schedule'){
      if(  workbookReports?.length > 0){
        setShowReportList(true)
      }
      setIsSendScheduled(true)
      dispatch(setModalOpen(true))
      dispatch(setMainContent(sendTypeSelected))
      dispatch(setSelectedModalContent(sendTypeSelected))
    }else{
      setIsSendScheduled(false)
      dispatch(setModalOpen(true))
      dispatch(setMainContent(sendTypeSelected))
      dispatch(setSelectedModalContent(sendTypeSelected))
    }
  }

  const handleGoBack = () => {
    if (selectedModalContent?.startsWith('edgeSubscriptionEdit-') || 
        selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') || 
        selectedModalContent?.startsWith('edgeSubscriptionHistory-')) {
      // Establecer que al regresar debe abrir en la pestaña 'tracking'
      setEdgeSubscriptionsInitialTab('tracking');
      dispatch(setSelectedModalContent('edgeSubscriptions'));
      return;
    }

    if(mainContent){
      switch (mainContent) {
        case 'selection':
          dispatch(setMainContent('filters'))
          break
        case 'sendNow':
          dispatch(setMainContent('send'))
          break 
        case 'schedule':
          dispatch(setMainContent('send'))
          break
        case 'filters':
          dispatch(setMainContent('home'))
          break
        case 'territories':
          dispatch(setMainContent('territories'))
          break
        default:
          dispatch(setModalOpen(false))
          dispatch(setMainContent('home'))
          break
      }
      dispatch(setModalOpen(false))
    }    
  }

  const resetTerritoryModalState = () => {
    setSelectedTerritory(null);
    setShowIframe(false);
    setHasUnsavedChanges(false);
  };

  return (
    <StyledWorkbookActions className={'workbook-actions'}>
      <Container className={'action-list'}>
        <Container className={'right-side'} >
          {
              isWorkbookActionsOpen && <WorkbookFilters/> 
          }
        </Container>
        {<Container className={'enabled left-side-container top'}>
          <Container className={'filter-actions'}>
            <Button className={'action-button'} onClick={() => { 
              dispatch(setModalOpen(true)); 
              dispatch(setSelectedModalContent('filters'))
              dispatch(setMainContent('filters'))
            }}>
              <Text>{yourFiltersLabel}</Text>
              <FilterListIcon />
            </Button>
            <Button
              className={'action-button'}
              onClick={() => {
                dispatch(setModalOpen(true));
                setSelectedFilter(selectedWorkbook?.controlFilter);
                dispatch(setSelectedModalContent('selection'))
                dispatch(setMainContent('selection'))
              }}
              tooltip={selectedWorkbook?.controlFilter?.name && { label: selectedWorkbook?.controlFilter?.name, position: 'bottom' }}
            >
                <Text>
                  {selectedWorkbookV2?.savedFilter?.savedFilterName || saveFilterLabel}
                </Text> 
              <Container className={'changes-indicator'}>
                {(selectedWorkbook?.controlFilter?.name && selectedWorkbook?.hasChanges) && <Text textStyle='s1'>(modified)</Text>}
              </Container>
              <SaveIcon />
            </Button>
          </Container>

          <Container>
            <Button 
              className={'action-button'}
              onClick={() => {
                resetTerritoryModalState();
                dispatch(setModalOpen(true)); 
                dispatch(setSelectedModalContent('territories'))
                dispatch(setMainContent('territories'))
              }}>
              <Text>Territories</Text>
              <AiOutlineFlag />
            </Button>
          </Container>

          <Container className={'send'} >
            <DropdownMenu
              label={'Send'}
              options={[
                { key: uuid(), label: 'Send Now', action: 'sendNow' },
                { key: uuid(), label: 'Schedule', action: 'schedule' }
              ]}
              onChange={(selectedOption:IOptionsSend)=>handleSendTypeChange(selectedOption)}
              disabled={!canDownload}
              arrorDirection="down-up"
            />
          </Container>

          <Container>
            <Button 
              className={'action-button'}
              disabled={!canDownload} 
              onClick={() => { 
                dispatch(setModalOpen(true)); 
                dispatch(setSelectedModalContent('download'))
                dispatch(setMainContent('download'))
              }}>
              <Text>Download</Text>
              <DownloadIcon />
            </Button>
          </Container>
        </Container>}
      </Container>
      <Modal
        position={`${selectedModalContent === 'premiumDownload' ? 'top':'center'}`}
        size={
          selectedModalContent === 'territories'
            ? (showIframe ? 'wide' : 'normal')
            : isEdgeSubscriptionsModal
            ? edgeSubscriptionsModalSize
            : 'normal'
        }
        isOpen={isModalOpen && selectedModalContent !== 'home'}
        requestClose={() => {
          dispatch(setModalOpen(false))
          if (selectedModalContent === 'posInvite' || selectedModalContent === 'edgeSubscriptions' || 
              selectedModalContent?.startsWith('edgeSubscriptionEdit-') || 
              selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') || 
              selectedModalContent?.startsWith('edgeSubscriptionHistory-')) {
            setTimeout(() => {
              dispatch(setSelectedModalContent('filters'));
            }, 300);
          } else {
            setTimeout(() => {
              dispatch(setSelectedModalContent('filters'));
            }, 300);
          }
          setInitialValues(fieldsInitialValuesExtended)
        }}
      >
        <Container className={'workbook-actions-modal'}>
          <Container className={'workbook-actions-modal-title'}>
            <Container className={'separator'} /> 
            <ArrowButton  
              className={`arrow-button ${(selectedModalContent?.startsWith('edgeSubscriptionEdit-') || 
                                          selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') || 
                                          selectedModalContent?.startsWith('edgeSubscriptionHistory-')) ? 'visible' : ''}`}
              backgroundColor='white' 
              color='brandDark' 
              onClick={handleGoBack}
            >
              <IoMdArrowBack size={25}/>
            </ArrowButton>
            <Container className="modal-title">
              <Text textStyle='h1'>
                {
                  selectedModalContent === 'territories'
                    ? (showIframe
                        ? (selectedTerritory?.name || 'Create New Territory')
                        : 'My Territories')
                    : selectedModalContent?.startsWith('edgeSubscriptionEdit-')
                    ? 'Edit Subscription'
                    : selectedModalContent?.startsWith('edgeSubscriptionDuplicate-')
                    ? 'Duplicate Subscription'
                    : selectedModalContent?.startsWith('edgeSubscriptionHistory-')
                    ? 'Subscription History'
                    : selecteSideMenuTabTitles[selectedModalContent]
                }
              </Text>
            </Container>
            {isEdgeSubscriptionsModal && (
              <Container className="edge-size-toggle">
                <DropdownMenu
                  label="Size"
                  selectedOption={selectedEdgeSubscriptionsSizeOption}
                  options={edgeSubscriptionsSizeOptions}
                  onChange={(option: { value: 'normal' | 'wide' | 'full' }) => setEdgeSubscriptionsModalSize(option.value)}
                />
              </Container>
            )}
            <Button onClick={handleCloseOnClick}>
              <IoMdClose size={'42px'} color={`${getColor('brandDark')}`} />
            </Button>
          </Container>
          {
            selectedModalContent === 'filters'
            && <WorkbookFilterList onEditFilter={onEditFilter} setIsModalOpen={(val:boolean)=>{dispatch(setModalOpen(val))}}/>
          }
          {
            selectedModalContent === 'selection'&& !isLoadingFilter && 
             <WorkbookFilterSave selectedState={selectedState} onSave={onSaveFilter} selectedFilter={selectedFilter} isEditFilterClicked={isEditFilterClicked} setIsEditFilterClicked={setIsEditFilterClicked}/>
          }
          {
            selectedModalContent === 'download'
            && <WorkbookDownload />
          }
          {
            selectedModalContent === 'territories' &&
            (showIframe
            ? 
              <WorkbookTerritories 
                onBack={() => setShowIframe(false)} 
                selectedTerritoryGuid={selectedTerritory?.id}
                onUnsavedChangesChange={setHasUnsavedChanges}
              />
              
            : <WorkbookTerritoryList onEdit={(territory) => {
                setSelectedTerritory(territory)
                setShowIframe(true)
              }} />)
          }
          {
            selectedModalContent === 'send'
            && <WorkbookSendExport />
          }
          {
            selectedModalContent === 'schedule' && initialValues
            && <WorkbookExport
                initialValues={initialValues} 
                selectedState={selectedState} 
                isSendScheduled = {isSendScheduled}
                onRequestClose={handleCloseOnClick} 
                selectedFilter={selectedWorkbookV2.savedFilter} 
                setShowReportList={(v: any) => setShowReportList(v)}  
                showReportList={showReportList} />
          }
          {
            selectedModalContent === 'premiumDownload' 
            && <PremiumDownload/>
          }
          {
            selectedModalContent === 'posInvite'
            && <POSInviteManager
                key={`pos-invite-${posInviteKey}`}
                isOpen={true}
                onClose={() => dispatch(setModalOpen(false))}
                userRole={userRole}
                brandName={brandName}
              />
          }
          {
            selectedModalContent === 'edgeSubscriptions'
            && <EdgeSubscriptionsManager
                key={`edge-subscriptions-${edgeSubscriptionsKey}`}
                isOpen={true}
                onClose={() => dispatch(setModalOpen(false))}
                initialTab={edgeSubscriptionsInitialTab}
                onTabChange={handleEdgeSubscriptionsTabChange}
              />
          }
          {
            selectedModalContent?.startsWith('edgeSubscriptionEdit-') && (
              <EdgeSubscriptionEditModal
                edgeGuid={selectedModalContent.replace('edgeSubscriptionEdit-', '')}
              />
            )
          }
          {
            selectedModalContent?.startsWith('edgeSubscriptionDuplicate-') && (
              <EdgeSubscriptionDuplicateModal
                edgeGuid={selectedModalContent.replace('edgeSubscriptionDuplicate-', '')}
              />
            )
          }
          {
            selectedModalContent?.startsWith('edgeSubscriptionHistory-') && (
              <EdgeSubscriptionHistoryModal
                subscriptionId={parseInt(selectedModalContent.split('-')[1])}
              />
            )
          }
          {
            selectedModalContent === 'sendNow' && initialValues
            && <WorkbookExport 
              initialValues={initialValues} 
              selectedState={selectedState} 
              isSendScheduled = {isSendScheduled}
              onRequestClose={setNowOnRequestClose} 
              selectedFilter={selectedWorkbookV2?.savedFilter} 
              setShowReportList={(v: any) => setShowReportList(v)} 
              showReportList={showReportList} />
          }
          {
            selectedModalContent === 'error'
            &&
            <Container className={'action-section'}>
              <Container className='suggestion'>
                <Text color='suggestion'>{filterWarningMessage}</Text>
                <Text color='suggestion'>{filterActionSuggestion}</Text>
              </Container>
              <Container className={'action-buttons'}>
                <Button onClick={() => dispatch(setModalOpen(false))}><Text>{okLabel}</Text></Button>
              </Container>
            </Container>
          }
        </Container>
      </Modal>
      
      <ConfirmDialog
        isOpen={showUnsavedChangesDialog}
        title="You have unsaved changes"
        message="You have unsaved changes. Are you sure you want to leave? Your changes will be lost."
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
        confirmText="Leave without saving"
        cancelText="Continue editing"
      />
    </StyledWorkbookActions>
  )
}
export default WorkbookActions
